module.exports = __webpack_public_path__ + "static/assets/856ca4df2276227c96de435175084bd0.svg";